export default "__VITE_ASSET__CclewvWN__"